
$('body').on('click', '.js-prod-filter', function (event) {
    event.preventDefault();

    $(this).find('.js-chevron-up').toggleClass("hidden");
    $(this).find('.js-chevron-down').toggleClass("hidden");
    $(this).parent().toggleClass('filter-panel--closed');

});

$('body').on('click', '.js-prod-category-toggle', function () {
    $(this).find('.js-chevron-up').toggleClass("hidden");
    $(this).find('.js-chevron-down').toggleClass("hidden");
    $(this).parent().find('.js-subcategory-list').toggleClass('categories--opened');
});

$('.js-list-control-dropdown').on('change', function () {
    window.location.href = $(this).find(":selected").data("url");
});



$('.js-filter-variant-input').on('click', function () {
    var location = $(this).parent().find('a').attr('href');
    window.location.href = location;
});